import { VideoMeetingChat } from "./VideoMeetingChat";
import { useChatVisibility } from "@platform/hooks/useChatVisibility";
import { useTalkJSData } from "@platform/hooks/useChat";
import { useMeetingChatConversationId } from "@platform/hooks/useMeetingChatConversationId";
import { useFetchUserCircles } from "@core/features/circle";
import { usePlatformStore } from "@platform/store";

export function VideoMeetingChatContainer() {
  const user = usePlatformStore((s) => s.user);
  const talkjsData = useTalkJSData();
  const conversationId = useMeetingChatConversationId();
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;
  const { shouldShowChat, isLoading } = useChatVisibility({ userCircles });

  if (isLoading || !shouldShowChat) {
    return null;
  }

  return (
    <VideoMeetingChat
      talkjsData={talkjsData}
      user={user}
      conversationId={conversationId}
    />
  );
}

export default VideoMeetingChatContainer;
